import LoadPicture from '../../Func/LoadPicture';
import DefaultLoading from '../../Components/Loading/DefaultLoading';
import CarouselSlide from '../../Components/Carousel/CarouselSlide';

const HomeCarousel = () => {

    const type = 'Cover'
    const Cover = LoadPicture(type)

    return (

        <>

            {!!Cover ? (

                <CarouselSlide data={Cover} />

            ) : (

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <DefaultLoading />
                </div>

            )}


        </>

    );
};

export default HomeCarousel;
